// TODO: Replace with Elysia/Eden Treaty API-derived types — these are duplicated from the API service
export const PLAYER_TYPE = 'player'
export const SCOUT_TYPE = 'scout'
export const SPECTATOR_TYPE = 'spectator'
